"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BACK_LINK = exports.FEEDBACK_PROMPT_RATING = exports.FEEDBACK_PROMPT = exports.MOVEOUT_VALIDATION_ERROR = exports.DATEPICKER_CALENDAR_CELL = exports.DATEPICKER_CALENDAR_NAV = exports.DATEPICKER_INPUT_BUTTON = exports.ERROR_SECTION = void 0;
exports.ERROR_SECTION = 'ErrorSection';
exports.DATEPICKER_INPUT_BUTTON = 'DatePickerInputButton';
exports.DATEPICKER_CALENDAR_NAV = 'DatePickerCalendarNav';
exports.DATEPICKER_CALENDAR_CELL = 'DatePickerCalendarCell';
exports.MOVEOUT_VALIDATION_ERROR = 'MoveoutValidationError';
exports.FEEDBACK_PROMPT = 'FeedbackPrompt';
exports.FEEDBACK_PROMPT_RATING = 'FeedbackPromptRating';
exports.BACK_LINK = 'BackLink';
